import React from 'react';
import { Outlet } from 'react-router';
import { SUBSCRIBER_PATH } from '../../../../constants';
const TrainingGroups = React.lazy(() => import('./index'));
const TrainingGroupDetails = React.lazy(() => import('./TrainingGroup/TrainingGroupDetails'));

// const GetNameOrganization = () => {
//      const orgUserLocal = JSON.parse(localStorage.getItem(LOCAL_ORG_USER));

//      return <span>Organization Training Group: {orgUserLocal && orgUserLocal.organization.name}</span>;
// };

const Routes = {
     path: SUBSCRIBER_PATH.ORGANIZATIONS_TRAINING_GROUPS,
     breadcrumb: 'Manage Training Groups',
     element: <Outlet />,
     children: [
          { index: true, element: <TrainingGroups /> },
          {
               path: SUBSCRIBER_PATH.ORGANIZATIONS_TRAINING_GROUPS_DETAILS,
               breadcrumb: 'Details',
               element: <TrainingGroupDetails />,
          },
     ],
};

export default Routes;
